var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import withPreact from "@skatejs/renderer-preact";
import { withComponent } from "skatejs";
import { extractWidgetConfiguration } from "./config/index";
/**
 * Base class for SgWidget.
 *
 * Will manage the renderRoot depending on your configuration options
 */
var SgWidget = /** @class */ (function (_super) {
    __extends(SgWidget, _super);
    function SgWidget() {
        var _this = _super.call(this) || this;
        var propsConfiguration = _this.constructor.props;
        if (propsConfiguration) {
            var propsKeys = Object.keys(propsConfiguration);
            for (var _i = 0, propsKeys_1 = propsKeys; _i < propsKeys_1.length; _i++) {
                var key = propsKeys_1[_i];
                if (Object.getOwnPropertyDescriptor(_this, key)) {
                    var thisAsAny = _this;
                    var currentValue = thisAsAny[key];
                    delete thisAsAny[key];
                    thisAsAny[key] = currentValue;
                }
            }
        }
        return _this;
    }
    Object.defineProperty(SgWidget.prototype, "widgetConfiguration", {
        get: function () {
            return extractWidgetConfiguration(this.constructor);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SgWidget.prototype, "renderRoot", {
        get: function () {
            if (this.widgetConfiguration.useShadowDOM) {
                return (this._shadowRoot ||
                    (this._shadowRoot = this.shadowRoot || attachShadow(this)));
            }
            else {
                return this;
            }
        },
        enumerable: true,
        configurable: true
    });
    return SgWidget;
}(withComponent(withPreact(HTMLElement))));
export { SgWidget };
function attachShadow(elem) {
    return elem.attachShadow ? elem.attachShadow({ mode: "open" }) : elem;
}
//# sourceMappingURL=SgWidget.js.map